import React from 'react'
import Link from 'next/link'
import { Pillow } from '@/components/Pillow/Pillow'
import { Text } from 'ui/src/components/Text/Text'
import { link, pillow } from './ProductPillow.css'

export type ProductPillowProps = {
  name: string
  label?: string
  image?: string
  url: string
  imagePriority?: boolean
}

export const ProductPillow = ({ name, image, url, imagePriority }: ProductPillowProps) => {
  return (
    <Link href={url} className={link}>
      <Pillow src={image} imagePriority={imagePriority} size="large" className={pillow} />
      <Text as="span" size="md">
        {name}
      </Text>
    </Link>
  )
}
